/**
 * 더채움돌봄펀드 후원 안내 컴포넌트
 * 펀드 소개 및 후원 방법을 안내하는 컴포넌트입니다.
 */

import React from 'react';
import styled, { css } from 'styled-components';
import QR1 from '../../assets/QR_1.png';
import QR2 from '../../assets/QR_2.png';

// 후원 데이터
const DONATION_DATA = {
  regular: {
    title: 'CMS 정기 후원',
    description: '간편 회원가입 (기부금영수증 가능)',
    qrImage: QR1,
    qrAlt: 'CMS 정기 후원 QR코드',
    link: 'https://my.bankcms.co.kr/Y63pFB',
  },
  account: {
    title: '계좌(일시)후원',
    description: '계좌이체로 후원하기',
    bank: '농협은행',
    accountNumber: '301-0317-1734-91',
    holder: '에스이임파워사회적협동조합',
    receipt: {
      title: '기부금영수증 신청',
      qrImage: QR2,
      qrAlt: '기부금영수증 신청 QR코드',
      link: 'https://forms.gle/WFXWcpPoMLQHCcBLA',
    },
  },
};

function FundInfo() {
  return (
    <Container>
      <Section>
        <Typography variant="main-title">
          함께 채워가는 돌봄, '더채움돌봄펀드'
        </Typography>

        {/* <IntroBox>
        <Typography>안녕하세요, 더채움돌봄을 함께해 주시는 여러분</Typography>
        <Typography>"요람에서 무덤까지."</Typography>
        <Typography>
          한때 복지 선진국을 상징하던 이 말은 여전히 중요하지만, 지금의 사회는
          그보다 더 빠르고 복잡하게 변하고 있습니다.
        </Typography>
        <Typography>
          이제는 정부의 공적 서비스만으로는 모두의 돌봄을 채우기 어렵습니다.
          그래서 우리는 이 질문에서 출발했습니다.
        </Typography>
        <Typography variant="highlight-question">
          "우리 국민은 세계 경제 10위만큼의 돌봄을 누리고 있는가?"
        </Typography>
      </IntroBox> */}

        {/* <Typography variant="section-title">
          더채움돌봄펀드, 그 시작의 의미
        </Typography> */}
        <Typography>
          더채움돌봄펀드는 돌봄이 필요한 분들에게 조금 더 따뜻한 일상을, 돌봄
          노동자들에게는 쉼과 응원을, 아이들에게는 문화와 꿈을, 그리고 아이들의
          따뜻한 식탁을 채워가는 프로젝트입니다.
        </Typography>
        <Typography>
          이 펀드는 단순한 모금이 아니라, 함께 만들어가는 새로운 돌봄을 실행하는
          일입니다.
        </Typography>
        <HighlightBox>
          "누군가의 하루를 조금 더 따뜻하게 만드는 참여"
        </HighlightBox>
        <Typography>그 한 걸음이 모여 세상을 바꾼다고 믿습니다.</Typography>
        <Typography variant="slogan">
          '내일을 위한 채움, 오늘을 위한 돌봄'은 우리의 소중한 참여로 키우는
          나무입니다.'
        </Typography>
      </Section>

      <Section $noMargin>
        <Typography variant="section-title">후원 안내</Typography>
        <CardContainer>
          <DonationCard>
            <Typography variant="card-title">
              {DONATION_DATA.regular.title}
            </Typography>
            <Typography variant="card-desc">
              {DONATION_DATA.regular.description}
            </Typography>
            <QRImage
              src={DONATION_DATA.regular.qrImage}
              alt={DONATION_DATA.regular.qrAlt}
            />

            <CardLink
              href={DONATION_DATA.regular.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              사이트 바로가기
            </CardLink>
          </DonationCard>

          <DonationCard>
            <Typography variant="card-title">
              {DONATION_DATA.account.title}
            </Typography>
            <Typography variant="card-desc">
              {DONATION_DATA.account.description}
            </Typography>
            <AccountInfo>
              <Typography variant="account-label">
                {DONATION_DATA.account.bank}
              </Typography>
              <Typography variant="account-number">
                {DONATION_DATA.account.accountNumber}
              </Typography>
              <Typography variant="account-holder">
                {DONATION_DATA.account.holder}
              </Typography>
            </AccountInfo>
            <ReceiptSection>
              <Typography variant="receipt-title">
                {DONATION_DATA.account.receipt.title}
              </Typography>
              <QRImage
                src={DONATION_DATA.account.receipt.qrImage}
                alt={DONATION_DATA.account.receipt.qrAlt}
              />

              <CardLink
                href={DONATION_DATA.account.receipt.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                기부자 정보입력
              </CardLink>
            </ReceiptSection>
          </DonationCard>
        </CardContainer>
      </Section>
      <Section>
        <Typography variant="section-title">
          더채움돌봄펀드 네이버카페
        </Typography>
        <SiteLink
          href="https://m.cafe.naver.com/ca-fe/tcdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          네이버 카페 바로가기 →
        </SiteLink>
      </Section>
    </Container>
  );
}

export default FundInfo;

/* Styled Components */

// 공통 스타일 헬퍼
const fontBold = css`
  font-family: 'koPubWorld DotumB';
`;
const fontMedium = css`
  font-family: 'koPubWorld DotumM';
`;
const mobile = (styles) =>
  css`
    @media (max-width: 767px) {
      ${styles}
    }
  `;

// Typography 다형성 컴포넌트
const typographyVariants = {
  default: css`
    font-size: 16px;
    ${fontBold}
    color: #333;
    line-height: 1.8;
    margin: 0 0 15px 0;
    word-break: keep-all;
    &:last-of-type {
      margin-bottom: 0;
    }
    ${mobile(
      css`
        font-size: 14px;
        line-height: 1.6;
      `
    )}
  `,
  'main-title': css`
    font-size: 28px;
    ${fontBold}
    color: #e5857c;
    margin: 0 0 15px 0;
    white-space: pre-line;
    word-break: keep-all;
    ${mobile(
      css`
        font-size: 22px;
        text-align: center;
      `
    )}
  `,
  'section-title': css`
    font-size: 20px;
    ${fontBold}
    color: #e5857c;
    margin: 0 0 20px 0;
    padding-bottom: 10px;
    border-bottom: 2px solid #e5857c;
    ${mobile(
      css`
        font-size: 17px;
        margin: 0 0 15px 0;
      `
    )}
  `,
  'highlight-question': css`
    font-size: 18px;
    ${fontBold}
    color: #2679b2;
    margin: 20px 0 0 0;
    text-align: center;
    word-break: keep-all;
    ${mobile(
      css`
        font-size: 15px;
      `
    )}
  `,
  slogan: css`
    font-size: 16px;
    ${fontBold}
    color: #e5857c;
    margin: 25px 0 0 0;
    padding: 15px 20px;
    text-align: center;
    background-color: #fdf5f4;
    border-radius: 8px;
    word-break: keep-all;
    ${mobile(
      css`
        font-size: 14px;
        padding: 12px 15px;
        margin: 20px 0 0 0;
      `
    )}
  `,
  'card-title': css`
    font-size: 18px;
    ${fontBold}
    color: #333;
    margin: 0 0 10px 0;
    text-align: center;
    ${mobile(
      css`
        font-size: 16px;
      `
    )}
  `,
  'card-desc': css`
    font-size: 14px;
    ${fontMedium}
    color: #666;
    margin: 0 0 20px 0;
    text-align: center;
    ${mobile(
      css`
        font-size: 13px;
        margin: 0 0 15px 0;
      `
    )}
  `,
  'account-label': css`
    font-size: 14px;
    ${fontBold}
    color: #2679b2;
    margin: 0 0 8px 0;
    ${mobile(
      css`
        font-size: 13px;
      `
    )}
  `,
  'account-number': css`
    font-size: 20px;
    ${fontBold}
    color: #333;
    margin: 0 0 8px 0;
    letter-spacing: 1px;
    ${mobile(
      css`
        font-size: 17px;
      `
    )}
  `,
  'account-holder': css`
    font-size: 13px;
    ${fontMedium}
    color: #666;
    margin: 0;
    ${mobile(
      css`
        font-size: 12px;
      `
    )}
  `,
  'receipt-title': css`
    font-size: 15px;
    ${fontBold}
    color: #333;
    margin: 0 0 15px 0;
    text-align: center;
    ${mobile(
      css`
        font-size: 14px;
      `
    )}
  `,
};

const Typography = styled.p`
  ${({ variant = 'default' }) => typographyVariants[variant]}
`;

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  ${mobile(
    css`
      padding: 0 5%;
    `
  )}
`;

const Section = styled.div`
  margin-bottom: ${({ $noMargin }) => ($noMargin ? '20px' : '40px')};
  ${mobile(
    css`
      margin-bottom: ${({ $noMargin }) => ($noMargin ? '20px' : '30px')};
    `
  )}
`;

const IntroBox = styled.div`
  margin-bottom: 40px;
  padding: 25px;
  background-color: #f8f9fa;
  border-radius: 8px;
  ${mobile(
    css`
      margin-bottom: 30px;
      padding: 20px;
    `
  )}
`;

const HighlightBox = styled.p`
  font-size: 17px;
  ${fontBold}
  color: #2679b2;
  margin: 20px 0;
  padding: 15px;
  background-color: #f0f7fc;
  border-left: 4px solid #2679b2;
  word-break: keep-all;
  ${mobile(
    css`
      font-size: 15px;
      padding: 12px;
    `
  )}
`;

const SiteLink = styled.a`
  display: inline-block;
  background-color: #e5857c;
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  text-decoration: none;
  font-family: 'Nanum Gothic Bold';
  font-size: 15px;
  transition: background-color 0.3s;
  &:hover {
    background-color: #d16f68;
  }
  &:active {
    background-color: #c05f58;
  }
  ${mobile(
    css`
      font-size: 13px;
      padding: 10px 20px;
    `
  )}
`;

const CardContainer = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  align-items: flex-start;
  ${mobile(
    css`
      flex-direction: column;
      gap: 20px;
    `
  )}
`;

const DonationCard = styled.div`
  flex: 1;
  min-width: 280px;
  padding: 25px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  ${mobile(
    css`
      padding: 20px;
      min-width: auto;
      width: 100%;
    `
  )}
`;

const QRImage = styled.img`
  display: block;
  width: 150px;
  height: 150px;
  margin: 0 auto 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  ${mobile(
    css`
      width: 120px;
      height: 120px;
      margin: 0 auto 15px;
    `
  )}
`;

const StepList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  ${mobile(
    css`
      gap: 4px;
      margin: 0 0 15px 0;
    `
  )}
`;

const StepItem = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  ${fontMedium}
  color: #666;
  span {
    padding: 4px 8px;
    background-color: #f5f5f5;
    border-radius: 4px;
  }
  &:not(:last-child)::after {
    content: '>';
    color: #999;
    font-size: 10px;
  }
  ${mobile(css`
    font-size: 11px;
    gap: 4px;
    span {
      padding: 3px 6px;
    }
    &:not(:last-child)::after {
      font-size: 9px;
    }
  `)}
`;

const CardLink = styled.a`
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #e5857c;
  color: #fff;
  font-size: 15px;
  ${fontBold}
  text-align: center;
  text-decoration: none;
  border-radius: 6px;
  transition: background-color 0.2s;
  &:hover {
    background-color: #d46b61;
  }
  ${mobile(
    css`
      font-size: 13px;
      padding: 10px;
    `
  )}
`;

const AccountInfo = styled.div`
  text-align: center;
  margin-bottom: 25px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  ${mobile(
    css`
      padding: 15px;
      margin-bottom: 20px;
    `
  )}
`;

const ReceiptSection = styled.div`
  border-top: 1px solid #e0e0e0;
  padding-top: 20px;
  ${mobile(
    css`
      padding-top: 15px;
    `
  )}
`;
